import React from 'react';
import { UrlView } from '../ConductAndEthics/style';

const MoreManServ = () => {
  return (
    <UrlView src="https://master.d2uuhae8jkdsq.amplifyapp.com/maisRedirect" />
  );
};
export default MoreManServ;
